module.exports = __webpack_public_path__ + "images/FUSA_icons/004-photo-camera.d9974164273096a1a0d4daf5cd992a45.svg";